var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{mobile: _vm.mobile}},[_c('p',[_vm._v(_vm._s(_vm.progressText[_vm.progressIndex]))]),(_vm.showInput)?_c('input',{attrs:{"type":"text","placeholder":"Enter code here"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }